/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
    CardContent,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    IconButton,
    Box,
    TablePagination,
} from '@material-ui/core';
import { Visibility, GetApp } from '@material-ui/icons';
import React, { useEffect } from 'react';
import { useRecordContext } from 'react-admin';
import { useDataProvider } from 'react-admin';
import { useTranslate } from 'react-admin';

export default function FacturesTab() {
    const [factures, setFactures] = React.useState([]);
    const [page, setPage] = React.useState(0); // Material-UI pagination starts at 0
    const [perPage, setPerPage] = React.useState(10);
    const [total, setTotal] = React.useState(0);

    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const record = useRecordContext();
    // if (!record) return null; // Ensure record is available

    const API_URL = process.env.REACT_APP_REST_API_URL;

    useEffect(() => {
        dataProvider
            .getList('factures', {
                pagination: { page: page + 1, perPage }, // React Admin pagination starts at 1
                sort: { field: 'date', order: 'DESC' },
                filter: { user: record.id }, // Assuming record has an id field
            })
            .then(({ data, total }) => {
                setFactures(data);
                setTotal(total);
            });
    }, [dataProvider, page, perPage, record]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleView = fileId => {
        if (fileId) {
            const viewLink = `${API_URL}/files/${fileId}/view`;
            window.open(viewLink, '_blank');
        }
    };

    const handleDownload = fileId => {
        if (fileId) {
            const downloadLink = `${API_URL}/files/${fileId}/download`;
            window.open(downloadLink, '_blank');
        }
    };

    const formatDate = dateString => {
        return new Date(dateString).toLocaleDateString();
    };

    console.log('Factures:', factures);

    return (
        <CardContent>
            <Typography variant="h6" gutterBottom>
                {translate('resources.factures.name', { smart_count: 2 })}
            </Typography>

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                {translate('resources.factures.fields.number')}
                            </TableCell>
                            <TableCell>
                                {translate('resources.factures.fields.date')}
                            </TableCell>
                            <TableCell align="center">
                                {translate('ra.action.show')}
                            </TableCell>
                            <TableCell align="center">
                                {translate('ra.action.export')}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {factures.map((facture: any) => (
                            <TableRow key={facture.id}>
                                <TableCell>
                                    <Typography variant="body2">
                                        {facture.number}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2">
                                        {formatDate(facture.date)}
                                    </Typography>
                                </TableCell>
                                <TableCell align="center">
                                    <IconButton
                                        color="primary"
                                        onClick={() => handleView(facture.file)}
                                        disabled={!facture.file}
                                        size="small"
                                    >
                                        <Visibility />
                                    </IconButton>
                                </TableCell>
                                <TableCell align="center">
                                    <IconButton
                                        color="secondary"
                                        onClick={() =>
                                            handleDownload(facture.file)
                                        }
                                        disabled={!facture.file}
                                        size="small"
                                    >
                                        <GetApp />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                        {factures.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={5} align="center">
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                    >
                                        {translate('ra.navigation.no_results')}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <TablePagination
                component="div"
                count={total}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={perPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
                labelRowsPerPage={translate('ra.navigation.page_rows_per_page')}
                labelDisplayedRows={({ from, to, count }) =>
                    translate('ra.navigation.page_range_info', {
                        offsetBegin: from,
                        offsetEnd: to,
                        total: count,
                    })
                }
            />
        </CardContent>
    );
}
